import { useEffect, useState } from "react"
import FeedCard from "./FeedCard"
import type { ListRequest } from "@/shared/types/commonResponse"
import { Typography } from "@/components/Typography"
import arrowRight from "@/assets/images/icons/arrowRight.svg"
import { useAlertDialog } from "@/shared/context/AlertDialogContext"
import { useAuth } from "@/shared/provider/AuthProvider"
import { useNavigate } from "react-router-dom"
import { getMediaType } from "@/shared/utils/media"
import {
  useFeedListWithSignedUrlQuery,
  useFormatImageMutation,
  type FormatImageRequest,
} from "@/service/api/feed"
import { STAR_ID } from "@/shared/constants/star"
import { useInView } from "react-intersection-observer"

type SignedFeedItem = {
  id: number
  content: string
  mediaUrl: string
  regDt: string
  signedUrl: string
}

interface Props {
  starAngkorId?: string
}

const Feed = ({ starAngkorId }: Props) => {
  const [feedList, setFeedList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 4,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const { showAlert, closeAlert } = useAlertDialog()
  const { userInfo } = useAuth()
  const navigate = useNavigate()

  const { ref, inView } = useInView({ triggerOnce: true })

  // API
  const { data: feedListDataWithSignedUrl = { content: [] } } =
    useFeedListWithSignedUrlQuery(feedList, {
      enabled: inView,
    })

  const handleRedirectApp = () => {
    window.location.href = `https://angkorlife.onelink.me/MIbi/?id=${userInfo?.token}&influencerInfo=${starAngkorId}`
  }

  const handleNavigate = () => {
    if (userInfo) {
      showAlert({
        logo: true,
        title: "Experience AngkorLife in the app!",
        description:
          "Enjoy even more content and features when you use the app.",
        actionText: "Continue in App",
        onConfirm: () => {
          handleRedirectApp()
          closeAlert()
        },
        hasSecondaryModal: true,
      })
    } else {
      showAlert({
        logo: false,
        title: "Would you like to log in?",
        actionText: "Log in",
        cancelText: "Cancel",
        onConfirm: () => navigate("/login"),
        onCancel: () => closeAlert(),
      })
    }
  }

  return (
    <div className="mb-5" ref={ref}>
      <div className="flex justify-between items-center py-4 mx-4 border-t border-Divider">
        <Typography variant="h6">Feed</Typography>

        <button onClick={handleNavigate} className="cursor-pointer">
          <Typography variant="caption" className="flex gap-1 items-center">
            View all
            <img src={arrowRight} alt="" />
          </Typography>
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3 px-4">
        {feedListDataWithSignedUrl?.content?.map((item) => (
          <FeedCard
            key={item.id}
            image={item.signedUrl || ""}
            content={item.content}
            postId={item.id}
          />
        ))}
      </div>
    </div>
  )
}

export default Feed
